import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: string;
  title: string;
  slug: string;
  thumbnail: string;
  duration: string;
  categoryName: string;
  views: number;
  date: string;
  rating: number;
}

function formatViews(n: number): string {
  if (n >= 10000) return (n / 10000).toFixed(1) + '万';
  return String(n);
}

export default function VideoCard({ id, title, slug, thumbnail, duration, categoryName, views, date, rating }: VideoCardProps) {
  return (
    <Link to={`/article/${id}`} className="group block cursor-pointer">
      <div className="relative aspect-video rounded-lg overflow-hidden bg-background-200 mb-3">
        <img
          src={thumbnail}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
        <span className="absolute bottom-2 right-2 px-2 py-0.5 text-xs font-medium text-background-50 bg-black/70 rounded-md whitespace-nowrap">
          {duration}
        </span>
        <span className="absolute top-2 left-2 px-2 py-0.5 text-xs font-medium text-background-50 bg-primary-500/90 rounded-md whitespace-nowrap">
          {rating}
        </span>
        <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-500/90 text-background-50">
            <i className="ri-play-fill text-2xl ml-0.5"></i>
          </div>
        </div>
      </div>
      <h3 className="text-sm font-semibold text-foreground-950 line-clamp-2 leading-snug mb-1.5 group-hover:text-primary-500 transition-colors">
        {title}
      </h3>
      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <span className="whitespace-nowrap">{categoryName}</span>
        <span className="whitespace-nowrap">{formatViews(views)}次播放</span>
        <span className="whitespace-nowrap">{date}</span>
      </div>
    </Link>
  );
}